<template>
	
	<div class="module_container full" style="position: relative;">
		<el-container class="full" style="position: relative;">
			<el-header height="auto" class="head" v-if="notice">
				<el-tag size="mini" type="danger">{{notice}}</el-tag>
			</el-header>
			<el-main style="padding: 5px;">
				<vxe-grid :ref="listref" v-if="list_gridOptions" v-bind="list_gridOptions"
					@toolbar-button-click="list_toolbarButtonClickEvent" :loading="loading"></vxe-grid>
				<edit-form ref="editForm" :supplieroptions="supplieroptions" :data="currentrow"
					@submit="editSubmit" />
				<purchase-form ref="purchaseForm" :data="puchasedata" @submit="purchaseFormSubmit" />
				<static-form ref="staticForm" :policytype="policytype" :data="staticdata" @submit="staticFormSubmit" />
				<custom-form ref="customForm" :warehouseid="warehouseid" @submit="customFormSubmit" @modalhide="customFormHide" :data="customdata" />
				<goods-box :data="currentrow" ref="goodsBox" @submit="goodsBoxSubmit" />
			</el-main>
		</el-container>
		
	</div>
</template>
<style scoped>
	.module_container {
		box-sizing: border-box;
		padding-top: 10px;
		padding-bottom: 10px;
	}
</style>
<script>
	import editForm from '../form/edit.vue'
	import purchaseForm from '../form/purchase.vue'
	import staticForm from '../form/static.vue'
	import customForm from '../form/custom.vue'
	import goodsBox from '../box/goods.vue'
	import listMixins from '@_system/components/base/mixins/list/list.js'
	export default {
		mixins: [listMixins],
		props: {
			data: {
				default: () => {
					return []
				}
			},
			warehouseid:{
				default: () => {
					return null
				}
			}
		},
		data() {
			return {
				notice:'系统自动排查【备货商品】',
				listref:"stockWarningStockupList",
				loading:false,
				puchasedata:[],
				staticdata:[],
				modal_title: 'title',
				modal_width: 600,
				modal_height: 500,
				policytype:311,
				supplieroptions:[],
				currentrow:{},
				customdata:{
					goodscode:[],
					warehouseid:0,
					policytype:0
				},
				list_formConfig: [{
					field: 'goodscode',
					title: '商品编码',
					itemRender: {
						name: '$input'
					}
				},{
					field: 'recommendlevel',
					title: '推荐等级',
					itemRender: {
						name: '$select',
						props:{
							emptyoption:false,
							multiple:true,
							selectoptions:[{
								value:'S',
								label:'S'
							},{
								value:'A',
								label:'A'
							},{
								value:'B',
								label:'B'
							},{
								value:'C',
								label:'C'
							},{
								value:'D',
								label:'D'
							},{
								value:'新品',
								label:'新品'
							}],
						},
					}
				},{
					field: 'supplierid',
					title: '供应商',
					itemRender: {
						props:{
							emptyoption:false,
							multiple:true
						},
						name: '$supplier'
					}
				}],
				list_columns: [{
						type: 'checkbox',
						title: '#',
						width: 50,
						fixed: 'left'
					},{
						field: 'goodscode',
						title: '商品编码',
						width: 100,
						fixed: 'left'
					},
					{
						field: 'goodsname',
						title: '商品名称',
						width: 100,
					},
					{
						field: 'goodsmodel',
						title: '商品型号',
						width: 100,
					},
					{
						field: 'weight',
						title: '商品重量(kg)',
						width: 100
					},
					{
						field: 'recommendlevel',
						title: '推荐等级',
						sortable:true,
						width: 100
					},
					{
						field: 'policytype',
						title: '策略类型',
						formatter:'policytype',
						width: 100
					},
					{
						field: 'lock',
						title: '锁定库存',
						width: 100
					},
					{
						field: 'quantity',
						title: '实际库存',
						width: 100
					},
					{
						field: 'underway',
						title: '在途库存',
						width: 100
					},
					{
						field: 'availableSize',
						title: '可用库存',
						width: 100
					},
					{
						field: 'warehouseid',
						title: '仓库',
						width: 100,
						fixed: 'left',
						formatter:'warehouse'
					},
					{
						field: 'bottom',
						title: '下限',
						width: 100
					},
					{
						field: 'top',
						title: '上限',
						width: 100
					},
					{
						field: 'custombottom',
						title: '自定义下限',
						width: 100
					},
					{
						field: 'customtop',
						title: '自定义上限',
						width: 100
					},
					{
						field: 'suggestnum',
						title: '建议采购数量',
						width: 100
					},
					{
						field: 'buynum',
						title: '近一年购买次数',
						width: 100
					},
					{
						field: 'prochasestandards',
						title: '采购标准',
						width: 100
					},
					{
						field: 'purchasenum',
						title: '本次采购数量',
						sortable:true,
						width: 100,
						fixed: 'right'
					},
					{
						field: 'suppliernameprovince',
						title: '省份',
						width: 100,
						formatter:'city',
						fixed: 'right',
					},
					{
						field: 'purchaseweight',
						title: '本次采购重量(kg)',
						sortable:true,
						width: 100
					},
					// {
					// 	field: 'mark',
					// 	title: '备注',
					// 	width: 100
					// },
					{
						field: 'supplierid',
						title: '推荐供应商',
						width: 200,
						sortable:true,
						fixed: 'right',
						formatter:'supplier'
					},
					{
						field: 'getday',
						title: '到仓天数',
						width: 80,
						fixed: 'right',
					},
					{
						field: 'customizedday',
						title: '定做天数',
						fixed: 'right',
						width: 80
					},
					{
						field: 'taxprice',
						title: '采购单价',
						width: 80,
					},
					{
						field: 'taxamount',
						title: '采购金额',
						sortable:true,
						width: 80,
						fixed: 'right'
					},
					{
						field: 'billCode',
						title: '采购订单',
						width: 100,
						sortable:true,
						fixed: 'right'
					},
					{
						field: 'warn_time',
						title: '预警时间',
						width: 100,
						formatter: 'datetime',
						fixed: 'right'
					},
					{
						title: '操作',
						fixed: "right",
						align: 'center',
						width: 100,
						slots: {
							default: ({row}) => {
								return [
									<el-button type = "text" size = "mini" onClick = {() => {this.edit(row)}}>编辑</el-button>,
									<el-button type = "text" size = "mini" onClick = {() => {this.recompute(row)}} style="color:#F56C6C">重置</el-button>
								]
							}
						}
					}					
				],
				list_footerField:[
					{field:'purchasenum',toFixed:0},
					{field:'taxamount',toFixed:2}
				]
			}
		},
		watch: {

		},
		computed: {
			device() {
				return window.systemMethods.device()
			}
		},
		created() {

		},
		mounted() {

		},	
		methods: {
			list_beforeCreateGrid(gridOptions) {
				gridOptions.formConfig.span = 4
				gridOptions.proxyConfig.autoLoad = false
				gridOptions.toolbarConfig.buttons = [{
					name: '生成采购单',
					status: 'primary',
					code: 'createpurchase'
				},{
					name: '统计',
					status: 'success',
					code: 'static'
				},{
					name: '重置',
					status: 'danger',
					code: 'recomputebatch'
				}]
			},
			//page,updateForm,other
			list(page,updateForm,other) {
				return new Promise((resolve) => {
					if(!this.warehouseid){
						this.$message.error('未选择仓库')
						resolve({list:[]})
					}else{
						this.$api.stockwarning.list({
							warehouseid:this.warehouseid,
							policytype:this.policytype,
							...page,
							...updateForm,
							...other,
							...this.foreingKey,
						}).then((res) => {
							resolve(res)
						})
					}
				})
			},
			getgrid(){
				return this.$refs[this.listref]
			},
			static(){
				this.staticdata = this.getgrid().getTableData().fullData
				this.$nextTick(()=>{
					this.$refs.staticForm.modal_show()
				})
			},
			
			createpurchase(puchasedata = []){
				if(!puchasedata.length){
					puchasedata = this.getgrid().getCheckboxRecords()
					if(!puchasedata.length){
						this.$message.error('请选择商品')
						return
					}
					if(puchasedata.length > 50){
						this.$message.error('商品明细一次不能超过50条')
						return
					}
				}


				this.puchasedata = puchasedata
				this.$nextTick(()=>{
					this.$refs.purchaseForm.modal_show()
				})
			},
			edit(row){
				this.supplieroptions = row.supplieroptions
				this.currentrow = row
				this.$nextTick(()=>{
					this.$refs.editForm.modal_show()
				})
			},
			recompute(row){
				let ids = [row.id]
				this.recomputehandle(ids)
			},
			recomputebatch(){
				let data = this.getgrid().getCheckboxRecords()
				if(!data.length){
					this.$message.error('请选择数据')
					return
				}
				let ids = data.map((item)=>{
					return item.id
				})
				this.$confirm('是否确认重置', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.recomputehandle(ids)
				}).catch(() => {
					
				})
			},
			recomputehandle(ids){
				this.loading = true
				this.$api.stockwarning.recompute({
					ids:ids
				}).then(() => {
					this.getgrid().commitProxy('query')
					this.loading = false
				},()=>{
					this.loading = false
				})
				
			},
			editSubmit(e){
				for(let i in e){
					if(i!='id'){
						this.currentrow[i] = e[i]
					}
				}
			},
			purchaseFormSubmit(){
				this.$emit('purchasesuccess')
			},
			staticFormSubmit(e){
				let data = this.getgrid().getTableData().fullData
				let puchasedata = []
				e.data.forEach((item)=>{
					let arr = data.filter((_item)=>{
						return _item.supplierid == item.id && e.recommendlevel.find(d=>d == _item.recommendlevel)
					})
					puchasedata = puchasedata.concat(arr)
				})

				this.createpurchase(puchasedata)
			},
			customFormShow(){
				this.$refs.customForm.modal_show()
			},
			customFormSubmit(){
				
			},
			customFormHide(){
				
			},
			goodsBoxSubmit(){

			},
			submit() {
				//this.init()
			},
			reset() {
				//this.init()
			}
		},
		components: {
			editForm,
			purchaseForm,
			staticForm,
			customForm,
			goodsBox
		}
	}
</script>